// extracted by mini-css-extract-plugin
export default {"clapyResets":"_resets_clapyResets__AS-85"};